package com.patronat.top.library.media.data

import io.ktor.utils.io.ByteReadChannel


class KmpFileSource(
    override val name: String,
    private val bytes: ByteArray,
    override val platformSource: Any? = null
) : FileSource {

    override val size: Long
        get() = bytes.size.toLong()


    override fun openStream(): ByteReadChannel {
        return ByteReadChannel(bytes)
    }
}